import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/lib/css-base'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

import speechComponentVue from '~root/src/components/speech-component-vue.vue?shadow'
window.customElements.define('speech-component-vue', wrap(Vue, speechComponentVue))